// extracted by mini-css-extract-plugin
export default {"products":"Ht-z","card":"It-z","oosMessaging":"Jt-z"};